
<h2>&nbsp;</h2>

<div id="animation_container" style=" width:1000px; height:400px; text-align:center;margin: 0 auto;">
		<canvas id="canvas" width="1000" height="400" style="position: absolute; display: block;"></canvas>
		<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; 
width:1000px; height:400px; position: absolute; left: 0px; top: 0px; display: block;">
		</div>
	</div>

   
